import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getPublisherInvoices } from 'api';

// Then, handle actions in your reducers:
const publisherInvoicesSlice = createSlice({
  name: 'publisherInvoices',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    publisherInvoicesFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    publisherInvoicesFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    publisherInvoicesFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    publisherInvoicesResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  publisherInvoicesFetchStart,
  publisherInvoicesFetchSuccess,
  publisherInvoicesFetchFail,
  publisherInvoicesResetState,
} = publisherInvoicesSlice.actions;

// The reducer
export const publisherInvoicesReducer = publisherInvoicesSlice.reducer;

// Asynchronous thunk action
export const publisherInvoicesFetch = (id: string) => (dispatch) => {
  dispatch(publisherInvoicesFetchStart());

  getPublisherInvoices(id)
    .then((publisherInvoices) => {
      dispatch(publisherInvoicesFetchSuccess(publisherInvoices.data));
    })
    .catch((error) => {
      dispatch(publisherInvoicesFetchFail(error));
    });
};
